<template>
  <div class="container">
    <h1>Our Partners</h1>
    <div class="row">
      <div class="col-md-6">
        <div class="card mb-3">
          <div class="card-body">
            <h5 class="card-title">Partner 1</h5>
            <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce euismod massa mauris, in venenatis nisl feugiat eu.</p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card mb-3">
          <div class="card-body">
            <h5 class="card-title">Partner 2</h5>
            <p class="card-text">Sed eu mauris sit amet enim commodo fermentum vel vel dolor. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PartnersView"
}
</script>

<style scoped>

</style>
